import { render, staticRenderFns } from "./UtilitySMS.vue?vue&type=template&id=03147064&"
import script from "./UtilitySMS.vue?vue&type=script&lang=js&"
export * from "./UtilitySMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports